import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faChevronDown,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";

function FilterReport({
  selectedReport,
  setFilters,
  filters,
  onApply,
  onClear,
  speakers,
  cities,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-lightPurple text-white text-sm font-semibold rounded-lg px-4 py-2 hover:bg-purpleColor uppercase flex items-center transition-all shadow-sm active:scale-95"
      >
        <FontAwesomeIcon
          icon={faFilter}
          className={`mr-1 transition-transform duration-300 ${isOpen ? "rotate-180" : "rotate-0"}`}
        />
        {isOpen ? "Hide Filters" : "Show Filters"}
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="absolute right-0 mt-3 w-[32rem] bg-white border border-gray-100 shadow-2xl rounded-xl z-50"
          >
            <div className="flex justify-between items-center bg-gray-50/50 px-6 py-4 border-b border-gray-100">
              <h3 className="font-semibold text-gray-800 text-lg">
                Filter Report
              </h3>
              <button
                onClick={onClear}
                className="text-sm font-medium uppercase text-red-500 hover:text-red-600 transition-colors"
              >
                Clear All
              </button>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-2 gap-6">
                <div className="flex flex-col">
                  <label className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                    From Date
                  </label>
                  <input
                    type="date"
                    name="dateFrom"
                    value={filters.dateFrom}
                    onChange={handleChange}
                    className="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 outline-none focus:ring-2 focus:ring-lightPurple transition-all"
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                    To Date
                  </label>
                  <input
                    type="date"
                    name="dateTo"
                    value={filters.dateTo}
                    onChange={handleChange}
                    className="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 outline-none focus:ring-2 focus:ring-lightPurple transition-all"
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                    Speaker
                  </label>
                  <select
                    name="speaker"
                    value={filters.speaker}
                    onChange={handleChange}
                    className="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 outline-none focus:ring-2 focus:ring-lightPurple transition-all"
                  >
                    <option value="">All Speakers</option>
                    {speakers?.map((speaker) => (
                      <option key={speaker.id} value={speaker.name}>
                        {speaker.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col">
                  <label className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                    City
                  </label>
                  <select
                    name="city"
                    value={filters.city}
                    onChange={handleChange}
                    className="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-700 outline-none focus:ring-2 focus:ring-lightPurple transition-all"
                  >
                    <option value="">All Cities</option>
                    {cities?.map((city, idx) => (
                      <option key={idx} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end">
              <button
                onClick={() => {
                  onApply();
                  setIsOpen(false);
                }}
                className="bg-gray-900 text-white px-5 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-all active:scale-95"
              >
                Apply Filters
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default FilterReport;
